var _g, _polygon, _g2, _g3, _path, _path2, _g4, _g5, _g6, _g7, _circle, _circle2, _g8, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWerteSpirit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 860.089 695.89",
    enableBackground: "new 0 0 860.089 695.89",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#684B93",
    d: "M432.003,255.904c51.09,56.954,46.281,144.492-10.773,195.505c-57.052,51.013-144.71,46.196-195.808-10.758 C174.325,383.688,179.15,296.18,236.2,245.15C293.249,194.135,380.912,198.947,432.003,255.904z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#C8EF93",
    d: "M324.43,494.523 M444.136,332.12 c-9.057-17.807-12.216-25.302-19.664-26.757c-10.273-2.01-12.959,7.987-18.631,13.197c-1.036,0.953-1.828,2.17-2.836,3.164 c-8.668,8.531-16.639,7.868-24.056-1.631c-4.786-6.133-9.742-12.182-15.166-17.74c-1.499-1.538-4.371-3.346-7.396-1.367 c-3.025,1.984-17.766,29.404,17.087,37.329c13.767,3.128,16.841,1.414,19.579,5.444c7.249,10.67-6.133,16.497-15.461,21.117 c-11.918,5.905,8.178,23.639-30.575,85.037c-6.203,9.831-30.466,9.515-34.879-0.958c-6.852-16.253-14.264-30.331-9.38-51.199 c4.882-20.868-11.739-39.561-17.688-41.068c-5.177-1.316-11.063-2.227-16.145-1.098c-23.683,5.236-36.976-8.961-36.722-32.072 c0.15-13.643,1.859-17.47,15.119-31.108c13.262-13.632,28.355-28.057,46.779-14.073c18.423,13.979,45.181,11.058,50.668,10.634 c5.488-0.425,6.824-5.584,6.627-8.039c-0.474-5.925-7.578-7.925-17.178-8.489c-10.949-0.642-18.631-11.737-28.5-16.424 c-3.952-1.875-9.833-1.367-14.308-0.093c-9.727,2.776-18.91,7.593-28.71,9.955c-7.837,1.896-11.198-3.045-7.816-10.53 c1.331-2.942,4.185-5.87,7.086-7.307c15.168-7.49,27.703-19.296,47.312-17.95c7.598,0.521,21.865-5.985,21.87-10.478 c0.013-9.038-4.11-9.665-4.11-9.665c76.221-0.88,139.429,58.566,140.336,138.325C465.954,367.678,453.192,349.928,444.136,332.12z"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#C6BCD6",
    points: "198.651,561.255 161.8,606.294 114.446,561.313 80.911,594.554 55.171,561.313 126.314,442.514 "
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000066493163351949773020000011839789574700093610_",
    x: 305.302,
    y: 371.13,
    width: 178.3,
    height: 186.657
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000165203150899668894920000013699805883504242848_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000066493163351949773020000011839789574700093610_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_00000165203150899668894920000013699805883504242848_)",
    fill: "#C6BCD6",
    points: "471.319,519.285  434.222,556.422 376.86,499.653 343.325,532.894 317.585,499.653 388.12,380.684  "
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000093163536836372898210000017486002213880578740_",
    points: "317.815,499.653 343.555,532.894  377.09,499.653 434.453,556.422 471.089,520.688 387.89,382.087  "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000054226094527496628560000007047684486400216743_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000093163536836372898210000017486002213880578740_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_00000054226094527496628560000007047684486400216743_)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: " M536.649,458.229L340.804,654.073 M533.45,453.749L337.604,649.594 M528.804,450.384L332.96,646.228 M525.602,445.904 L329.76,641.747 M521.172,442.751L325.327,638.595 M517.97,438.269L322.126,634.115 M513.327,434.907L317.483,630.75  M510.128,430.425L314.283,626.269 M506.204,427.151L310.359,622.995 M503.002,422.669L307.157,618.513 M498.359,419.304 L302.514,615.148 M495.157,414.824L299.312,610.669 M490.727,411.671L294.88,607.515 M487.526,407.19L291.68,603.034  M482.882,403.826L287.037,599.67 M479.681,399.346L283.835,595.189 M475.484,396.462L279.641,592.305 M472.287,391.979 L276.44,587.824 M467.642,388.616L271.796,584.46 M464.44,384.135L268.595,579.978 M460.007,380.983L264.165,576.825  M456.809,376.502L260.964,572.347 M452.165,373.138L256.32,568.983 M448.964,368.655L253.118,564.501 M445.04,365.381 L249.194,561.225 M441.841,360.9L245.995,556.744 M437.198,357.536L241.349,553.381 M433.996,353.057L238.148,548.899  M429.563,349.903L233.718,545.746 M426.364,345.422L230.516,541.266 M421.721,342.056L225.873,537.901 M418.519,337.577 L222.674,533.419"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#694A93",
    strokeWidth: 1.697,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M284.462,552.496l-57.765-71.697l-44.597,52.59 M549.447,649.446L388.116,380.691L226.667,649.948"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#694A93",
    strokeWidth: 1.697,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M238.635,628.978L126.559,442.308L21.05,615.278"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000158008802357953930630000004112868553520864922_",
    x: 42.887,
    y: 432.961,
    width: 168.046,
    height: 174.698
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000005981731476266623310000003483580746252889502_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000158008802357953930630000004112868553520864922_",
    overflow: "visible"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#684B93",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M577.396,620.545c0,0,0.824-120.187-30.43-174.471"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#684B93",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M587.264,446.074c0,0-16.848,35.578-18.704,68.372"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#684B93",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M572.24,538.937c0,0-27.744-32.002-51.595-31.179"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#684B93",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M630.62,593.424c0,0-3.876-70.039,54.517-119.387"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#684B93",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M646.897,460.057c0,0,2.783,55.619-1.913,67.067"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#684B93",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M635.935,552.422c0,0-14.949-19.914-23.175-25.298"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#95DD3A",
    d: "M601.622,440.656c0,6.543-5.31,11.853-11.853,11.853c-6.549,0-11.855-5.31-11.855-11.853 c0-6.548,5.306-11.855,11.855-11.855C596.312,428.801,601.622,434.108,601.622,440.656z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#95DD3A",
    d: "M555.948,440.656c0,6.543-5.307,11.853-11.853,11.853c-6.547,0-11.853-5.31-11.853-11.853 c0-6.548,5.306-11.855,11.853-11.855C550.641,428.801,555.948,434.108,555.948,440.656z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#95DD3A",
    d: "M532.497,507.742c0,6.545-5.307,11.855-11.853,11.855c-6.545,0-11.855-5.31-11.855-11.855 c0-6.547,5.31-11.853,11.855-11.853C527.19,495.89,532.497,501.196,532.497,507.742z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#95DD3A",
    d: "M624.615,523.339c0,6.547-5.307,11.853-11.855,11.853c-6.544,0-11.853-5.306-11.853-11.853 c0-6.545,5.308-11.854,11.853-11.854C619.308,511.485,624.615,516.794,624.615,523.339z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#95DD3A",
    d: "M659.568,457.927c0,6.545-5.31,11.855-11.853,11.855c-6.545,0-11.855-5.31-11.855-11.855 c0-6.543,5.31-11.853,11.855-11.853C654.258,446.074,659.568,451.384,659.568,457.927z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#95DD3A",
    d: "M701.513,469.782c0,6.543-5.31,11.853-11.853,11.853c-6.545,0-11.853-5.31-11.853-11.853 c0-6.545,5.307-11.855,11.853-11.855C696.203,457.927,701.513,463.237,701.513,469.782z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#95DD3A",
    d: "M450.737,655.804h392.315c0,0-35.363-60.861-81.423-21.383c-84.716-56.751-155.445-46.885-189.99-19.741 C507.486,584.248,450.737,655.804,450.737,655.804z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    stroke: "#684B93",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 735.769,641.887 708.428,641.887 702.276,586.523 739.871,586.523  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    stroke: "#684B93",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 746.022,586.523 696.811,586.523 698.86,571.487 743.97,571.487  "
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#684B93",
    cx: 514.746,
    cy: 144.767,
    r: 55.386
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#95DD3A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    d: "M514.117,144.138c0,0,0-49.092,0-83.079 c45.316,0,82.45,39.022,82.45,83.708C537.404,144.767,514.117,144.138,514.117,144.138z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#95DD3A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    cx: 224.889,
    cy: 97.627,
    r: 34.224
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#95DD3A",
    cx: 240.575,
    cy: 66.73,
    r: 11.883
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#95DD3A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    d: "M583.316,219.25c0,0,5.008-7.109,11.497-7.109 s8.148,8.562,16.157,8.562c8.011,0,10.221-8.562,16.71-8.562s9.667,8.562,16.57,8.562c6.906,0,9.805-8.562,16.294-8.562 s9.251,8.562,16.294,8.562c7.044,0,8.975-8.562,16.848-8.562"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#95DD3A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    d: "M550.765,238.79c0,0,5.006-7.108,11.496-7.108 s8.148,8.562,16.157,8.562c8.008,0,10.218-8.562,16.71-8.562c6.49,0,9.664,8.562,16.57,8.562s9.805-8.562,16.294-8.562 c6.492,0,9.254,8.562,16.294,8.562c7.044,0,8.978-8.562,16.848-8.562"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#95DD3A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    d: "M550.765,257.404c0,0,5.006-7.108,11.496-7.108 s8.148,8.562,16.157,8.562c8.008,0,10.218-8.562,16.71-8.562c6.49,0,9.664,8.562,16.57,8.562s9.805-8.562,16.294-8.562 c6.492,0,9.254,8.562,16.294,8.562c7.044,0,8.978-8.562,16.848-8.562"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#694A94",
    strokeWidth: 2,
    d: "M229.767,111.215c-86.676,0-156.94,70.264-156.94,156.939 c0,86.676,70.264,156.94,156.94,156.94s156.94-70.264,156.94-156.94c0-23.683-5.246-46.14-14.639-66.273"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#290A3D",
    strokeWidth: 2,
    d: "M229.767,137.581c-72.114,0-130.574,58.459-130.574,130.574 c0,72.113,58.46,130.572,130.574,130.572s130.574-58.459,130.574-130.572"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#95DD3A",
    strokeWidth: 2,
    d: "M229.767,164.845c-57.057,0-103.31,46.254-103.31,103.311 c0,57.056,46.253,103.309,103.31,103.309c32.846,0,62.113-15.328,81.035-39.223"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#B2A6C9",
    strokeWidth: 2,
    d: "M229.767,192.819c-41.607,0-75.337,33.729-75.337,75.337 c0,41.607,33.73,75.337,75.337,75.337s75.337-33.73,75.337-75.337c0-8.321-1.349-16.327-3.84-23.812"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWerteSpirit);
export default __webpack_public_path__ + "static/media/werte_spirit.df493f62338123676a095ce64db127f4.svg";
export { ForwardRef as ReactComponent };